import { render, staticRenderFns } from "./GalleryModal.vue?vue&type=template&id=ba652ae6&scoped=true"
import script from "./GalleryModal.vue?vue&type=script&lang=js"
export * from "./GalleryModal.vue?vue&type=script&lang=js"
import style0 from "./GalleryModal.vue?vue&type=style&index=0&id=ba652ae6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba652ae6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba652ae6')) {
      api.createRecord('ba652ae6', component.options)
    } else {
      api.reload('ba652ae6', component.options)
    }
    module.hot.accept("./GalleryModal.vue?vue&type=template&id=ba652ae6&scoped=true", function () {
      api.rerender('ba652ae6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/event/cavesEducationAuthorize/components/GalleryModal.vue"
export default component.exports